import api from '../../API';

function Test(){
    return (
        <>
        <h1>BDSA Test</h1>
        </>
    )
}

export default Test;